import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { ComponentsModule } from "@components";
import { SlickButtonSpinnerModule, SlickConfirmDialogModule, SlickDatePickerModule, SlickDialogModule } from "@slick-components";
import { CrmEditComponent } from "./crm-edit.component";
import { CrmEditDialogComponent } from "./crm-edit-dialog.component";

// crm-edit has its own module so the CRM page can show it without importing CustomerComponentsModule
// just for the dialog, and so the panel can be reused anywhere else without dragging the customer
// editor along with it.
@NgModule({
	imports: [CommonModule, FormsModule, ComponentsModule, SlickButtonSpinnerModule, SlickConfirmDialogModule, SlickDatePickerModule, SlickDialogModule],
	declarations: [CrmEditComponent, CrmEditDialogComponent],
	exports: [CrmEditComponent, CrmEditDialogComponent]
})
export class CrmEditModule { }

export { CrmEditComponent }
export { CrmEditDialogComponent }
